import MainPage from 'navigation/pages/MainPage';
import { bindMethod } from 'helpers/bind';
import PageHeader from 'components/page-header/PageHeader';
import modulesMap from 'core/modulesMap';
import DragController from 'components/drag-controller/DragController';
import ImageZoom from 'sections/editorial/ImageZoom';
import { forceArray } from 'navigation/component/Component';
import Footer from 'components/footer/Footer';
class Collection extends MainPage {
    getModulesMap() {
        return {
            pageHeader: ['.page-header', PageHeader],
            draggable: ['.collections__wrapper', DragController],
            footer: ['.footer', Footer],
            zoom: ['.image-zoom', ImageZoom],
            ...modulesMap
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            pageManager: this.pageManager,
            gradient: true
        };
    }
    initialized() {
        super.initialized();
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        forceArray(this.refs.lookItems).forEach((item, i) => {
            item[method]('click', () => this.modules.zoom.open(i));
        });
    }
    resize = () => {
        super.resize();
    };
}
export default Collection;
